"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var fetch_exports = {};
__export(fetch_exports, {
  get: () => get,
  head: () => head,
  options: () => options,
  patch: () => patch,
  post: () => post,
  put: () => put,
  remove: () => remove,
  request: () => request,
  trace: () => trace
});
module.exports = __toCommonJS(fetch_exports);
var import_io = require("@cartographerio/io");
var import_types = require("@cartographerio/types");
var import_cross_fetch = __toESM(require("cross-fetch"));
var import_fetchHelpers = require("./fetchHelpers.js");
var import_headers = require("./headers.js");
var import_response = require("./response.js");
var import_url = require("./url.js");
function request(url, options2) {
  const { logFetchRequest, logFetchResponse, logFetchError } = (0, import_fetchHelpers.fetchLogger)();
  const fullOptions = {
    ...options2,
    headers: { ...(0, import_fetchHelpers.defaultHeaders)(), ...options2.headers ?? {} }
  };
  return logFetchRequest(url, fullOptions).flatMap(
    (ctx) => import_io.IO.fromPromise(() => (0, import_cross_fetch.default)(url, fullOptions)).tap((response) => logFetchResponse(ctx, response)).tapError((error) => console.log("error", error)).flatMap((response) => (0, import_response.createResponse)(response)).recover(
      (error) => logFetchError(ctx, error).andThen(
        import_io.IO.fail(
          (0, import_types.networkError)("Could not contact the server", {
            method: options2.method,
            url,
            error
          })
        )
      )
    )
  );
}
function fetchWithoutBody(method) {
  return function(args) {
    const {
      apiParams: { apiConfig, auth },
      url,
      redirect
    } = args;
    return request((0, import_url.formatUrl)(apiConfig.baseUrl, url), {
      method,
      headers: (0, import_headers.combineHeaders)((0, import_headers.authHeaders)(apiConfig, auth), import_headers.jsonHeaders),
      redirect
    });
  };
}
function fetchWithBody(method) {
  return function(args) {
    const {
      apiParams: { apiConfig, auth },
      url,
      redirect,
      body
    } = args;
    return request((0, import_url.formatUrl)(apiConfig.baseUrl, url), {
      method,
      body: body instanceof FormData ? body : JSON.stringify(body),
      headers: (0, import_headers.combineHeaders)((0, import_headers.authHeaders)(apiConfig, auth), import_headers.jsonHeaders),
      redirect
    });
  };
}
const get = fetchWithoutBody("GET");
const post = fetchWithBody("POST");
const put = fetchWithBody("PUT");
const remove = fetchWithoutBody("DELETE");
const head = fetchWithoutBody("HEAD");
const options = fetchWithoutBody("OPTIONS");
const patch = fetchWithBody("PATCH");
const trace = fetchWithoutBody("TRACE");
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  get,
  head,
  options,
  patch,
  post,
  put,
  remove,
  request,
  trace
});
//# sourceMappingURL=fetch.js.map
